import { useLocation, useNavigate } from 'react-router-dom';

export function useBackNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    const pathSegments = location.pathname.split('/').filter((segment) => segment !== '');
    if (pathSegments.length > 1) {
      const parentPath = '/' + pathSegments.slice(0, -1).join('/');
      navigate(parentPath);
    }
  };
}